import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/SawitK.css"; // Menggunakan styling umum
import axios from "axios";
import Swal from "sweetalert2";

const Sawit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [hargaSawit, setHargaSawit] = useState([]);
  const [currentPageSawit, setCurrentSawit] = useState(1);
  const itemsPerPage = 5;

  // Modal states for Sawit
  const [showModal, setShowModal] = useState(false);
  const [nama, setNama] = useState("");
  const [usia, setUsia] = useState("");
  const [harga, setHarga] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);

  // Modal states for Pupuk
  const [hargaPupuk, setHargaPupuk] = useState([]);
  const [showPupukModal, setShowPupukModal] = useState(false);
  const [namaPupuk, setNamaPupuk] = useState("");
  const [hargaPupukPerKg, setHargaPupukPerKg] = useState("");
  const [deskripsiPupuk, setDeskripsiPupuk] = useState("");
  const [selectedPupukId, setSelectedPupukId] = useState(null);
  const [pupukErrorMessage, setPupukErrorMessage] = useState("");

  // Modal states for adding Sawit type
  const [showTambahSawitModal, setShowTambahSawitModal] = useState(false);
  const [namaSawit, setNamaSawit] = useState("");
  const [deskripsiSawit, setDeskripsiSawit] = useState("");
  const [tambahSawitErrorMessage, setTambahSawitErrorMessage] = useState("");

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    const fetchSawitData = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/view_sawit",
          { withCredentials: true }
        );
        const sortedData = response.data.map((item) => {
          if (Array.isArray(item.harga_usia)) {
            item.harga_usia.sort((a, b) => a.usia - b.usia);
          } else {
            item.harga_usia = [];
          }
          return item;
        });
        setHargaSawit(sortedData);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchSawitData();
  }, []);

  const fetchPupukData = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_pupuk",
        { withCredentials: true }
      );
      setHargaPupuk(response.data.pupuks || []);
    } catch (error) {
      console.error("Error fetching pupuk data:", error);
    }
  };

  useEffect(() => {
    fetchPupukData();
  }, []);

  const handlePageChangeSawit = (pageNumber) => {
    setCurrentSawit(pageNumber);
  };

  const totalPagesSawit = Math.ceil(hargaSawit.length / itemsPerPage);
  const currentSawitItems = hargaSawit.slice(
    (currentPageSawit - 1) * itemsPerPage,
    currentPageSawit * itemsPerPage
  );

  const handleShowModal = (item) => {
    setNama(item.nama);
    setUsia(item.usia || "");
    setHarga(item.harga || "");
    setSelectedItemId(item.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNama("");
    setUsia("");
    setHarga("");
    setErrorMessage("");
    setSelectedItemId(null);
  };

  const handleAddSawit = async () => {
    if (!nama || !usia || !harga) {
      setErrorMessage("Nama, usia, dan harga harus diisi!");
      return;
    }
    const payload = {
      nama: nama,
      usia: parseInt(usia),
      harga: parseFloat(harga),
    };
    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/add_harga_sawit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 201) {
        // Fetch ulang agar struktur array harga_usia up to date
        const res = await axios.get("https://c-greenproject.org:7500/view_sawit", { withCredentials: true });
        const sortedData = res.data.map((item) => {
          if (Array.isArray(item.harga_usia)) item.harga_usia.sort((a, b) => a.usia - b.usia);
          return item;
        });
        setHargaSawit(sortedData);
        handleCloseModal();
        Swal.fire("Sukses", "Harga sawit berhasil ditambahkan", "success");
      } else {
        setErrorMessage(response.data.error || "Terjadi kesalahan, coba lagi.");
      }
    } catch (error) {
      setErrorMessage("Terjadi kesalahan saat mengirim data.");
      console.error(error);
    }
  };

  const handleEditSawit = async () => {
    if (!nama || !usia || !harga) {
      setErrorMessage("Nama, usia, dan harga harus diisi!");
      return;
    }

    const payload = {
      jenis_sawit_id: selectedItemId,
      usia: parseInt(usia),
      harga: parseFloat(harga),
    };

    try {
      const response = await axios.put(
        "https://c-greenproject.org:7500/edit_harga_sawit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        const res = await axios.get("https://c-greenproject.org:7500/view_sawit", { withCredentials: true });
        const sortedData = res.data.map((item) => {
          if (Array.isArray(item.harga_usia)) item.harga_usia.sort((a, b) => a.usia - b.usia);
          return item;
        });
        setHargaSawit(sortedData);
        handleCloseModal();
        Swal.fire("Sukses", "Data berhasil diperbarui!", "success");
      } else {
        setErrorMessage(response.data.error || "Terjadi kesalahan, coba lagi.");
      }
    } catch (error) {
      setErrorMessage("Terjadi kesalahan saat mengirim data.");
      console.error(error);
    }
  };

  const handleAddPupuk = async () => {
    if (!namaPupuk || hargaPupukPerKg === "" || !deskripsiPupuk) {
      setPupukErrorMessage("Nama, harga per kg, dan deskripsi harus diisi!");
      return;
    }

    const payload = {
      nama: namaPupuk,
      harga_per_kg: parseFloat(hargaPupukPerKg),
      deskripsi: deskripsiPupuk,
    };

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/add_pupuk",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 201) {
        setHargaPupuk((prevState) => [...prevState, response.data.pupuk || payload]);
        handleClosePupukModal();
        Swal.fire("Sukses", "Pupuk berhasil ditambahkan", "success");
        fetchPupukData();
      } else {
        setPupukErrorMessage(response.data.error || "Terjadi kesalahan, coba lagi.");
      }
    } catch (error) {
      setPupukErrorMessage("Terjadi kesalahan saat mengirim data.");
    }
  };

  const handleEditPupuk = async () => {
    if (!namaPupuk || hargaPupukPerKg === "" || !deskripsiPupuk) {
      setPupukErrorMessage("Nama, harga per kg, dan deskripsi harus diisi!");
      return;
    }

    const payload = {
      nama: namaPupuk,
      harga_per_kg: parseFloat(hargaPupukPerKg),
      deskripsi: deskripsiPupuk,
    };

    try {
      const response = await axios.put(
        `https://c-greenproject.org:7500/edit_pupuk/${selectedPupukId}`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        fetchPupukData();
        handleClosePupukModal();
        Swal.fire("Sukses", "Data pupuk berhasil diperbarui!", "success");
      } else {
        setPupukErrorMessage(response.data?.error || "Terjadi kesalahan, coba lagi.");
      }
    } catch (error) {
      setPupukErrorMessage(error.response?.data?.error || "Terjadi kesalahan saat mengirim data.");
      console.error(error);
    }
  };

  const handleClosePupukModal = () => {
    setShowPupukModal(false);
    setNamaPupuk("");
    setHargaPupukPerKg("");
    setDeskripsiPupuk("");
    setPupukErrorMessage("");
    setSelectedPupukId(null);
  };

  const handleTambahSawit = async () => {
    if (!namaSawit || !deskripsiSawit) {
      setTambahSawitErrorMessage("Nama dan deskripsi jenis sawit harus diisi!");
      return;
    }

    const payload = {
      nama: namaSawit,
      deskripsi: deskripsiSawit,
    };

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/add_sawit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 201) {
        Swal.fire("Sukses", "Jenis sawit berhasil ditambahkan!", "success");
        setShowTambahSawitModal(false);
        setNamaSawit("");
        setDeskripsiSawit("");
        setTambahSawitErrorMessage("");
        
        // Refresh data
        const res = await axios.get("https://c-greenproject.org:7500/view_sawit", { withCredentials: true });
        const sortedData = res.data.map((item) => {
          if (Array.isArray(item.harga_usia)) item.harga_usia.sort((a, b) => a.usia - b.usia);
          return item;
        });
        setHargaSawit(sortedData);
      } else {
        setTambahSawitErrorMessage(response.data.error || "Terjadi kesalahan, coba lagi.");
      }
    } catch (error) {
      setTambahSawitErrorMessage("Terjadi kesalahan saat menambah jenis sawit.");
      console.error(error);
    }
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar (Sesuai Role Petani/Umum) */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.startsWith("/petani") && !location.pathname.includes("rt") && !location.pathname.includes("rp") && !location.pathname.includes("fp") && !location.pathname.includes("p") ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirt" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px" }} /> Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/panen.png" alt="Harvest" style={{ width:"20px", marginRight:"10px" }} /> Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanifp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/FinalPanen.png" alt="Final Panen" style={{ width:"20px", marginRight:"10px" }} /> Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanip" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/sell_8087698.png" alt="Sales" style={{ width:"20px", marginRight:"10px" }} /> Penjualan
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Informasi Harga Sawit & Pupuk</h2>
            <button className="btn kembali-button px-4" onClick={handleBack}>
              Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Harga Sawit */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white mb-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4 pb-3 border-bottom">
              <h4 className="fw-bold text-success mb-0">Daftar Harga Sawit</h4>
              
              {userInfo.role !== "petani" && (
                <div className="d-flex flex-wrap gap-2">
                  <button
                    className="btn btn-outline-secondary rounded-pill px-4 fw-medium text-nowrap shadow-sm"
                    onClick={() => setShowTambahSawitModal(true)}
                  >
                    <i className="fa fa-plus me-2"></i>Tambah Jenis Sawit
                  </button>
                  <button
                    className="btn btn-success rounded-pill px-4 fw-medium text-nowrap shadow-sm"
                    onClick={() => {
                      setSelectedItemId(null);
                      setNama("");
                      setUsia("");
                      setHarga("");
                      setShowModal(true);
                    }}
                  >
                    <i className="fa fa-tag me-2"></i>Tambah Harga Sawit
                  </button>
                </div>
              )}
            </div>

            {currentSawitItems && currentSawitItems.length > 0 ? (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle" style={{ minWidth: "900px" }}>
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                      <th className="py-3" style={{ width: "160px" }}>Nama Jenis</th>
                      <th className="py-3" style={{ width: "150px" }}>Harga Per Kg</th>
                      <th className="py-3" style={{ width: "120px" }}>Usia</th>
                      <th className="py-3" style={{ width: "200px" }}>Tanggal Diperbarui</th>
                      <th className="py-3" style={{ borderTopRightRadius: "10px" }}>Deskripsi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentSawitItems.map((item, index) => (
                      <tr key={`sawit-${item.id || index}`}>
                        <td className="text-center fw-bold text-muted" style={{ verticalAlign: "top", paddingTop: "15px" }}>
                          {(currentPageSawit - 1) * itemsPerPage + index + 1}
                        </td>
                        <td className="fw-bold text-dark text-capitalize" style={{ verticalAlign: "top", paddingTop: "15px" }}>
                          {item.nama}
                        </td>
                        <td style={{ verticalAlign: "top", padding: "0" }}>
                          {Array.isArray(item.harga_usia) && item.harga_usia.length > 0 ? (
                            item.harga_usia.map((data, idx) => (
                              <div key={`harga-${idx}`} className="font-monospace text-success fw-semibold px-2 py-2" style={{ borderBottom: idx !== item.harga_usia.length - 1 ? "1px solid #dee2e6" : "none" }}>
                                Rp {Number(data.harga).toLocaleString("id-ID")}
                              </div>
                            ))
                          ) : (
                            <div className="text-muted px-2 py-2">-</div>
                          )}
                        </td>
                        <td style={{ verticalAlign: "top", padding: "0" }}>
                          {Array.isArray(item.harga_usia) && item.harga_usia.length > 0 ? (
                            item.harga_usia.map((data, idx) => (
                              <div key={`usia-${idx}`} className="text-muted px-2 py-2" style={{ borderBottom: idx !== item.harga_usia.length - 1 ? "1px solid #dee2e6" : "none" }}>
                                {data.usia} Tahun
                              </div>
                            ))
                          ) : (
                            <div className="text-muted px-2 py-2">-</div>
                          )}
                        </td>
                        <td style={{ verticalAlign: "top", padding: "0" }}>
                          {Array.isArray(item.harga_usia) && item.harga_usia.length > 0 ? (
                            item.harga_usia.map((data, idx) => (
                              <div key={`tgl-${idx}`} className="text-muted small px-2 py-2" style={{ borderBottom: idx !== item.harga_usia.length - 1 ? "1px solid #dee2e6" : "none" }}>
                                {new Date(data.tanggal).toLocaleString("id-ID", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </div>
                            ))
                          ) : (
                            <div className="text-muted px-2 py-2">-</div>
                          )}
                        </td>
                        <td className="text-muted" style={{ verticalAlign: "top", paddingTop: "15px" }}>
                          {item.deskripsi || "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3">
                <i className="fa fa-seedling mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Data Sawit</h5>
                <p className="mb-0">Data harga sawit belum tersedia saat ini.</p>
              </div>
            )}

            {/* Pagination Sawit */}
            <nav className="mt-4">
              <ul className="pagination justify-content-end mb-0">
                <li className={`page-item ${currentPageSawit === 1 ? "disabled" : ""}`}>
                  <button className="page-link shadow-none rounded-start-pill" onClick={() => handlePageChangeSawit(currentPageSawit - 1)}>
                    Previous
                  </button>
                </li>
                {[...Array(totalPagesSawit)].map((_, index) => (
                  <li key={`page-sawit-${index + 1}`} className={`page-item ${currentPageSawit === index + 1 ? "active" : ""}`}>
                    <button className="page-link shadow-none" onClick={() => handlePageChangeSawit(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPageSawit === totalPagesSawit || totalPagesSawit === 0 ? "disabled" : ""}`}>
                  <button className="page-link shadow-none rounded-end-pill" onClick={() => handlePageChangeSawit(currentPageSawit + 1)}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>

          {/* Table Container Harga Pupuk */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4 pb-3 border-bottom">
              <h4 className="fw-bold text-success mb-0">Daftar Harga Pupuk</h4>
              {userInfo.role !== "petani" && (
                <button
                  className="btn btn-success rounded-pill px-4 fw-medium text-nowrap shadow-sm"
                  onClick={() => setShowPupukModal(true)}
                >
                  <i className="fa fa-box me-2"></i>Tambah Harga Pupuk
                </button>
              )}
            </div>

            {Array.isArray(hargaPupuk) && hargaPupuk.length > 0 ? (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle" style={{ minWidth: "800px" }}>
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                      <th className="py-3" style={{ width: "200px" }}>Nama Pupuk</th>
                      <th className="py-3" style={{ width: "180px" }}>Harga per Kg</th>
                      <th className="py-3" style={{ borderTopRightRadius: "10px" }}>Deskripsi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hargaPupuk.map((pupuk, index) => (
                      <tr key={`pupuk-${pupuk.id || index}`}>
                        <td className="text-center fw-bold text-muted">{index + 1}</td>
                        <td className="fw-bold text-dark">{pupuk.nama}</td>
                        <td className="font-monospace text-success fw-semibold">
                          Rp {Number(pupuk.harga_per_kg).toLocaleString("id-ID")}
                        </td>
                        <td className="text-muted">{pupuk.deskripsi || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3">
                <i className="fa fa-boxes mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Data Pupuk</h5>
                <p className="mb-0">Data harga pupuk belum tersedia saat ini.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal Tambah Jenis Sawit */}
      {showTambahSawitModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.6)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">Tambah Jenis Sawit</h5>
                <button type="button" className="btn-close shadow-none" onClick={() => setShowTambahSawitModal(false)}></button>
              </div>
              <div className="modal-body px-4 py-3">
                {tambahSawitErrorMessage && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3">{tambahSawitErrorMessage}</div>
                )}
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2">Nama Jenis Sawit</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    value={namaSawit}
                    onChange={(e) => setNamaSawit(e.target.value)}
                    placeholder="Contoh: Tenera"
                  />
                </div>
                <div className="form-group mb-0">
                  <label className="fw-semibold text-muted mb-2">Deskripsi</label>
                  <textarea
                    className="form-control rounded-3"
                    rows="3"
                    value={deskripsiSawit}
                    onChange={(e) => setDeskripsiSawit(e.target.value)}
                    placeholder="Masukkan deskripsi..."
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button type="button" className="btn btn-light rounded-pill px-4 fw-medium" onClick={() => setShowTambahSawitModal(false)}>
                  Batal
                </button>
                <button type="button" className="btn btn-success rounded-pill px-4 fw-bold shadow-sm" onClick={handleTambahSawit}>
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Tambah / Edit Harga Sawit */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.6)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">
                  {selectedItemId ? "Edit Harga Sawit" : "Tambah Harga Sawit"}
                </h5>
                <button type="button" className="btn-close shadow-none" onClick={handleCloseModal}></button>
              </div>
              <div className="modal-body px-4 py-3">
                {errorMessage && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3">{errorMessage}</div>
                )}
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2">Nama Sawit</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    value={nama}
                    onChange={(e) => setNama(e.target.value)}
                    placeholder="Masukkan Nama Sawit"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2">Usia (Tahun)</label>
                  <input
                    type="number"
                    className="form-control form-control-lg rounded-3 fs-6"
                    value={usia}
                    onChange={(e) => setUsia(e.target.value)}
                    placeholder="Contoh: 5"
                  />
                </div>
                <div className="form-group mb-0">
                  <label className="fw-semibold text-muted mb-2">Harga (Rp)</label>
                  <input
                    type="number"
                    className="form-control form-control-lg rounded-3 fs-6"
                    value={harga}
                    onChange={(e) => setHarga(e.target.value)}
                    placeholder="Masukkan Harga"
                  />
                </div>
              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button type="button" className="btn btn-light rounded-pill px-4 fw-medium" onClick={handleCloseModal}>
                  Batal
                </button>
                <button type="button" className="btn btn-primary rounded-pill px-4 fw-bold shadow-sm" onClick={selectedItemId ? handleEditSawit : handleAddSawit}>
                  {selectedItemId ? "Update" : "Simpan"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Tambah / Edit Harga Pupuk */}
      {showPupukModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.6)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">
                  {selectedPupukId ? "Edit Harga Pupuk" : "Tambah Harga Pupuk"}
                </h5>
                <button type="button" className="btn-close shadow-none" onClick={handleClosePupukModal}></button>
              </div>
              <div className="modal-body px-4 py-3">
                {pupukErrorMessage && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3">{pupukErrorMessage}</div>
                )}
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2">Nama Pupuk</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    value={namaPupuk}
                    onChange={(e) => setNamaPupuk(e.target.value)}
                    placeholder="Masukkan Nama Pupuk"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2">Harga per Kg (Rp)</label>
                  <input
                    type="number"
                    className="form-control form-control-lg rounded-3 fs-6"
                    value={hargaPupukPerKg}
                    onChange={(e) => setHargaPupukPerKg(e.target.value)}
                    placeholder="Masukkan Harga per Kg"
                  />
                </div>
                <div className="form-group mb-0">
                  <label className="fw-semibold text-muted mb-2">Deskripsi</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    value={deskripsiPupuk}
                    onChange={(e) => setDeskripsiPupuk(e.target.value)}
                    placeholder="Masukkan Deskripsi"
                  />
                </div>
              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button type="button" className="btn btn-light rounded-pill px-4 fw-medium" onClick={handleClosePupukModal}>
                  Batal
                </button>
                <button type="button" className="btn btn-primary rounded-pill px-4 fw-bold shadow-sm" onClick={selectedPupukId ? handleEditPupuk : handleAddPupuk}>
                  {selectedPupukId ? "Update" : "Simpan"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sawit;